import { DefaultNodeModelOptions, NodeModel, NodeModelGenerics } from "@projectstorm/react-diagrams";
import { CustomPortModel } from "./CustomPortModel";

export interface CustomNodeModelGenerics {
  PORT: CustomPortModel;
  OPTIONS?: DefaultNodeModelOptions;
}

export class CustomNodeModel extends NodeModel<NodeModelGenerics & CustomNodeModelGenerics> {
  constructor(options?: DefaultNodeModelOptions) {
    super({
      type: "custom",
      ...options,
    });
  }
}
